import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Platform } from 'react-native';

import en from './en.json';
import pl from './pl.json';
import ru from './ru.json';
import ua from './ua.json';

const LANGUAGE_STORAGE_KEY = '@app_language';

const resources = {
  en: {
    translation: en,
  },
  pl: {
    translation: pl,
  },
  ru: {
    translation: ru,
  },
  ua: {
    translation: ua,
  },
};

// Helper to get AsyncStorage (only on native)
const getAsyncStorage = () => {
  if (Platform.OS === 'web') {
    // Use localStorage on web
    return {
      getItem: (key: string) => Promise.resolve(localStorage.getItem(key)),
      setItem: (key: string, value: string) => Promise.resolve(localStorage.setItem(key, value)),
    };
  }
  // Dynamically require AsyncStorage only on native
  return require('@react-native-async-storage/async-storage').default;
};

// Функция для сохранения языка
export const saveLanguage = async (language: string) => {
  try {
    const storage = getAsyncStorage();
    await storage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    console.warn('Ошибка сохранения языка:', error);
  }
};

// Функция для загрузки сохраненного языка
const loadSavedLanguage = async (): Promise<string> => {
  try {
    const storage = getAsyncStorage();
    const savedLanguage = await storage.getItem(LANGUAGE_STORAGE_KEY);
    return savedLanguage || 'pl';
  } catch (error) {
    console.warn('Ошибка загрузки языка:', error);
    return 'pl';
  }
};

// Get initial language synchronously from localStorage on web
const getInitialLanguage = (): string => {
  if (Platform.OS === 'web') {
    try {
      return localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'pl';
    } catch {
      return 'pl';
    }
  }
  return 'pl'; // Default for native, will be updated async
};

// Initialize i18n synchronously with default language
i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

// Подписываемся на изменения языка для автосохранения
i18n.on('languageChanged', lng => {
  saveLanguage(lng);
});

// On native, load saved language asynchronously and update if different
if (Platform.OS !== 'web') {
  loadSavedLanguage().then(savedLanguage => {
    if (savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }
  });
}

export default i18n;
